// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-LeftSide-module--cls1--1td2Q","cls2":"contacts-LeftSide-module--cls2--2zPJ2 contacts-LeftSide-module--cls1--1td2Q"};